export default {
	referenceGrid: {
		bindsInfo: "Информация про привязки",
		appsToWhichBaseLinked: "Приложения, к которым привязана база",
		toUnlinkAppsGoToDeleteMenu: "Для отвязки конкретных приложений от базы перейдите в меню удаления",
		currentBaseNotLinkedToApp: "данная база не привязана к приложениям",
		basesLinkedToApp: "Базы, которые привязаны к приложению",
		packetsWithSection: "Пакеты, в которых учавствует приложение",
		noPacketsWithSection: "нет пакетов, использующих это приложение",
		toDeletePackets: "Для удаления пакетов перейдите в Крон соответствующего сервера",
		toUnlinkBasesGoToDeleteMenu: "Для отвязки конкретных баз от приложения перейдите в меню удаления",
		noLinkedBasesToCurrentApp: "к данному приложению не привязаны базы",
		enterDataForNewApp: "Введите данные нового приложения",
		copied: "Копируется",
		copyAttention: "Внимание: копирование приложения выполняется в пределах одного сервера",
		name: "Название",
		alias: "Алиас",
		path: "Путь",
		cancel: "Отменить",
		insert: "Добавить",
		copy: "Копировать",
		info: "Информация",
		edit: "Редактировать",
		delete: "Удалить",
		view: "Вид",
		compact: "Оптимальный",
		full: "Полный",
		enterNameForNewApp: "Введите название нового приложения",
		enterPathForNewApp: "Введите путь нового приложения",
		desirableEnterAliasField: "Желательно заполнять поле 'Алиас'",
		continueWithoutAlias: "Продолжать без заполнения",
		attention: "Внимание",
		continue: "Продолжать",
		return: "Вернуться"
	}
}